import { WarningFilled } from '@ant-design/icons';
import type { RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';
import styled from 'styled-components';
import { getBackgroundColor, getIconColor, getTextColor } from './disease-tag.utils';

interface StyledProps {
  $riskLevel: RiskLevelEnum;
}

export const Container = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  padding: 2px 6px;
  gap: 4px;
  border-radius: 4px;
  background-color: ${({ $riskLevel }) => getBackgroundColor($riskLevel)};
`;

export const Icon = styled(WarningFilled)<StyledProps>`
  color: ${({ $riskLevel }) => getIconColor($riskLevel)};
  font-size: 14px;
`;

export const Text = styled.div<StyledProps>`
  color: ${({ $riskLevel }) => getTextColor($riskLevel)};
  font-weight: 600;
  font-size: 12px;
  font-family: 'Noto Sans';
  line-height: 22px;
`;
